module.exports = __webpack_public_path__ + "static/media/Desktop 20-3-2566 22-35-14.71e7b564.gif";